import styled, {css} from "styled-components"
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({theme}) => css`
    width: 100%;
    height: 100%;
    min-height: 760px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: ${theme.colors.mainBg};
    padding-top: 20px;
    padding-bottom: 80px;

    ${media.lessThan("medium")`
        padding-top: 0;
        padding-bottom: 40px;
    `}
  `}
`

export const Content = styled.div.attrs(() => ({
  className: 'container',
}))`
  max-width: 1100px !important;

  ${media.lessThan("medium")`
      width: 95% !important;
      margin: 0 auto;
  `}

`

export const Title = styled.div`
  ${({theme}) => css`
    width: 100%;
    font-family: ${theme.font.family};
    font-weight: ${theme.font.ultra};
    font-size: ${theme.font.sizes.huge};
    line-height: ${theme.font.sizes.xlarge};
    letter-spacing: 0;
    color: ${theme.colors.white};
    text-transform: uppercase;
    text-align: center;
    padding: 35px 0 90px;

    ${media.lessThan("medium")`
      font-size: ${theme.font.sizes.xxlarge};
      padding: 35px 0 50px;
    `}
  `}
`

export const BoxPlans = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* alterado de 2 para 3 */
  gap: 4rem 2rem;
  justify-items: center;
  max-width: 100rem;
  margin: 0 auto 100px auto;
  padding: 0 1rem;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
    gap: 4rem 0;
  `}
`


